// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eBfI","textarea":"styles_textarea__1OWV1"};